import { ChevronRight } from "lucide-react";

export const SettingsCard = ({
  icon: Icon,
  label,
  onClick,
  rightElement,
}: {
  icon: React.ElementType;
  label: string;
  onClick?: () => void;
  rightElement?: React.ReactNode;
}) => (
  <div
    className="group w-full bg-white rounded-xl shadow-sm p-4 md:p-6 transition-all duration-200 cursor-pointer"
    style={{ background: "white" }}
    onClick={onClick}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "linear-gradient(135deg, #4368E5, #2F6EDA)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "white";
    }}
  >
    <div className="flex items-center justify-between p-3 md:p-4">
      <div className="flex items-center space-x-3 md:space-x-4 flex-1 min-w-0">
        <Icon className="text-[#6A6A6A] group-hover:text-white flex-shrink-0 w-5 h-5 md:w-6 md:h-6 transition-colors" />
        <span className="text-[#6A6A6A] group-hover:text-white text-sm md:text-base font-medium truncate transition-colors">
          {label}
        </span>
      </div>
      <div className="flex-shrink-0 ml-2">
        {rightElement || (
          <ChevronRight className="text-gray-400 group-hover:text-white w-5 h-5 md:w-6 md:h-6 transition-colors" />
        )}
      </div>
    </div>
  </div>
);
